import $ from 'jquery';
// import { breakpoints } from './_site';
import { create as createSlider } from './slider';

export const create = ($el) => {
    // main banner
    createSlider($el, {
        fade: false,
        // draggable: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        // adaptiveHeight: true,
        // autoplay: true,
        // autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        responsive: [
            // {
            //     breakpoint: breakpoints.md,
            //     settings: {
            //         draggable: true
            //     }
            // },
            // {
            //     breakpoint: breakpoints.sm,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // },
            // {
            //     breakpoint: breakpoints.xs,
            //     settings: {
            //         draggable: true,
            //         dots: true,
            //         fade: true
            //     }
            // }
        ]
    });
};
export const openModalSlider = ($el) => {
    var $modal = $('#compare-modal'),
        $slider = $modal.find('.slider__cycle'),
        $slideTarget = $($el.data('fabric-modal')),
        position = $slideTarget.data('pos');

    $slider.slick('slickGoTo', position-1);
};
export const binds = () => {
    create($('.modal-slider'));

    // ---------------- open fabric modal with slideshow
    $('body').on('click', '[data-fabric-modal]', function (event) {
        event.preventDefault();
        openModalSlider($(this));
    });
};
